import React,{Component} from 'react';

export class Loader extends Component {
	render(){
		return (
			<div id="loader-container">
                <i className="fa fa-gavel"></i>      
                <span>Loading...</span>
            </div>
		)
	}
}
